import { ComparisonMode, Context } from "../../constants"
import type { Authorization, AuthorizationCheck, AuthorizationCheckers } from "../../types"

export const useAuthorized = (
  resource: { authorizations?: Authorization } | undefined,
): AuthorizationCheckers => {
  const authorizations: { actions?: string[]; fields?: string[] } = resource?.authorizations || {}

  const isAuthorizedToEvery = (to: string[], context: string[]) => {
    return to.every(action => context.includes(action))
  }

  const isAuthorizedToSome = (to: string[], context: string[]) => {
    return to.some(action => context.includes(action))
  }

  const notAuthorized = (to: string[], context: string[]) => !isAuthorizedToEvery(to, context)

  const permissionCheckForMode: Record<ComparisonMode, AuthorizationCheck> = {
    [ComparisonMode.And]: isAuthorizedToEvery,
    [ComparisonMode.Or]: isAuthorizedToSome,
    [ComparisonMode.Not]: notAuthorized,
  }

  const isAuthorized = (
    to: string[],
    context: Context = Context.Actions,
    mode: ComparisonMode = ComparisonMode.And,
  ) => {
    if (to.length === 0) return true
    const contextArray = authorizations?.[context] || []

    return permissionCheckForMode[mode](to, contextArray)
  }

  return { isAuthorized, isAuthorizedToEvery, isAuthorizedToSome }
}
